var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFo = function SvgFo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-78.015 32h640v480h-640z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(78.02 -32)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-78.015 32h663.91v480h-663.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.033 218.67h185.9V32h106.23v186.67h371.79v106.67h-371.79v186.67h-106.23V325.34h-185.9V218.67z",
    fill: "#003897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.033 245.33h212.45V32h53.113v213.33h398.35v53.333H189.53v213.33h-53.113v-213.33h-212.45V245.33z",
    fill: "#d72828"
  }))));
};
export default __webpack_public_path__ + "assets/b8d61ed787e5f5615d9a8337c512f8a8.svg";
export { SvgFo as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/fo.svg